import {
  Combobox,
  useCombobox,
  Text,
  Button,
  useMantineColorScheme,
} from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"

export function DepartmentSelect({
  data,
  value: selectedValue,
  onChange,
}: {
  data: { value: string; label: string }[]
  value: string | null
  onChange: (v: string) => void
}) {
  const selectedItem = selectedValue
    ? (data.find((v) => v.value === selectedValue) ?? null)
    : null
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  })

  const options = data.map((item) => (
    <Combobox.Option value={item.value} key={item.value}>
      {item.label}
    </Combobox.Option>
  ))
  const { colorScheme } = useMantineColorScheme()

  return (
    <Combobox
      store={combobox}
      width={250}
      position="bottom-start"
      withArrow
      onOptionSubmit={(val) => {
        onChange(val)
        combobox.closeDropdown()
      }}
    >
      <Combobox.Target>
        <Button
          px={0}
          variant="subtle"
          color={colorScheme === "dark" ? "gray.0" : "dark.8"}
          style={{
            background: "none",
            border: "none",
          }}
          onClick={() => {
            combobox.openDropdown()
          }}
          rightSection={
            options.length > 1 ? <IconChevronDown size={14} /> : null
          }
        >
          <Text fw={500} size="xl">
            {selectedItem?.label || "Nothing selected"}
          </Text>
        </Button>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options
          onChange={(v) => {
            console.log({ v })
          }}
        >
          {options}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
